import { render, staticRenderFns } from "./NewComment.vue?vue&type=template&id=cf092f0e&scoped=true&"
import script from "./NewComment.vue?vue&type=script&lang=js&"
export * from "./NewComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf092f0e",
  null
  
)

export default component.exports